import axios from 'components/Axios';
import {
  Login,
  // insertSignup,
  sendMail,
  validateEmail,
  validateMobile,
  sendMobileOtp,
  Mobilelogin,
  Resetpassmbl,
  Resetpassemail,
  verifyResetPassMbl,
  verifyResetPassEmail,
  validateUser,
  changeMailorPhone,
  changeRole,
  Changepass,
  changeAutoFollowRequest,
  googleSignup,
  updateUsernameOTP,
  changeUserName,
  appleSignup,
} from '../APIEndPoint';

const userLogin = (payload, type) => {
  const promise = axios.post(
    `${type === 'email' ? Login : Mobilelogin}`,
    payload
  );
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

// const userCreate = (payload) => {
//   const promise = axios.post(`${insertSignup}`, payload);
//   const dataPromise = promise.then((response) => response);
//   return dataPromise;
// };

const SendMail = (payload) => {
  const promise = axios.post(`${sendMail}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const ValidateMail = (payload) => {
  const promise = axios.post(`${validateEmail}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const SendMobileOtp = (payload) => {
  const promise = axios.post(`${sendMobileOtp}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const ValidateMoileOtp = (payload, apiname) => {
  const promise = axios.post(`${apiname || validateMobile}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UserNameCreate = (payload, UserId) => {
  const promise = axios.put(`${`user/updateUsername/${UserId}`}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UserGoogleSignup = (payload) => {
  const promise = axios.post(googleSignup, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const UserAppleSignup = (payload) => {
  const promise = axios.post(appleSignup, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const ResetPassApi = (payload, type) => {
  const promise = axios.post(
    `${type === 'email' ? Resetpassemail : Resetpassmbl}`,
    payload
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const ValidateUser = (payload, userId) => {
  const promise = axios.put(`${validateUser}/${userId}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetUpdateUsernameOTP = (payload) => {
  const promise = axios.put(updateUsernameOTP, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const ChangeUserName = (payload) => {
  const promise = axios.post(changeUserName, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const ChangeUserRole = (data, userId) => {
  const payload = {
    accountType: data,
  };
  const promise = axios.put(`${changeRole}/${userId}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const handleFollowAutoAccept = (autoFollowRequest) => {
  const payload = {
    autoFollowRequest,
  };
  const promise = axios.put(`${changeAutoFollowRequest}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const ChangePassword = (payload, userId) => {
  const promise = axios.put(`${Changepass}/${userId}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const VerifyEmailAndPhoneSettingsApi = (payload) => {
  const promise = axios.post(`${changeMailorPhone}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const VerifyResetPass = (payload, type) => {
  const promise = axios.post(
    `${type === 'email' ? verifyResetPassEmail : verifyResetPassMbl}`,
    payload
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  userLogin,
  UserGoogleSignup,
  UserAppleSignup,
  // userCreate,
  SendMail,
  ValidateMail,
  ValidateMoileOtp,
  SendMobileOtp,
  UserNameCreate,
  ResetPassApi,
  VerifyResetPass,
  ChangePassword,
  ValidateUser,
  GetUpdateUsernameOTP,
  ChangeUserName,
  VerifyEmailAndPhoneSettingsApi,
  ChangeUserRole,
  handleFollowAutoAccept,
};
